import { render, staticRenderFns } from "./RentBox.vue?vue&type=template&id=e33ccaee&"
import script from "./RentBox.vue?vue&type=script&lang=js&"
export * from "./RentBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports